<section class="h-screen flex flex-col bg-primary-800 dark:bg-slate-900">

  <!-- Logo -->
  <div class="flex items-center gap-3 px-5 py-4 border-b border-white/10 dark:border-white/5 flex-shrink-0">
    <img src="icons/direct-logo-footer.png" alt="Direct Savings & Loans" class="h-10 w-auto"/>
    <p class="text-[9px] font-semibold uppercase tracking-[0.22em] text-white/40">Back Office</p>
  </div>

  <!-- Navigation -->
  <div class="flex-1 overflow-y-auto py-4 px-3">

    <!-- Main Section -->
    <p class="text-[9px] font-bold uppercase tracking-widest px-3 mb-2 text-white/30">Main</p>
    <nav class="space-y-0.5 mb-6">

      <!-- Dashboard -->
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'dashboard' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/dashboard')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <img [src]="_images.dashboardIconWhite" alt="Dashboard" class="w-4 h-4 flex-shrink-0 transition-opacity"
            [ngClass]="activeMenuItem === 'dashboard' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'" />
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'dashboard' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            Dashboard
          </span>
          @if (activeMenuItem === 'dashboard') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>

      <!-- Institutions -->
      @if (permissionService.canAccess('institutions')) {
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'institutions' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/institutions')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <img [src]="_images.transactionIconWhite" alt="Institutions" class="w-4 h-4 flex-shrink-0 transition-opacity"
            [ngClass]="activeMenuItem === 'institutions' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'" />
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'institutions' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            Institutions
          </span>
          @if (activeMenuItem === 'institutions') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>
      }

      <!-- Categories -->
      @if (permissionService.canAccess('categories')) {
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'categories' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/categories')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <svg class="w-4 h-4 flex-shrink-0 transition-opacity text-white"
            [ngClass]="activeMenuItem === 'categories' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M7 7h.01M7 3H5a2 2 0 00-2 2v2a2 2 0 00.586 1.414l8 8a2 2 0 002.828 0l5.172-5.172a2 2 0 000-2.828l-8-8A2 2 0 007 3z" />
          </svg>
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'categories' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            Categories
          </span>
          @if (activeMenuItem === 'categories') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>
      }

      <!-- Products -->
      @if (permissionService.canAccess('products')) {
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'products' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/products')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <svg class="w-4 h-4 flex-shrink-0 transition-opacity text-white"
            [ngClass]="activeMenuItem === 'products' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'products' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            Products
          </span>
          @if (activeMenuItem === 'products') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>
      }

      <!-- Loan Applications -->
      @if (permissionService.canAccess('applications')) {
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'loan-applications' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/loan-applications')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <svg class="w-4 h-4 flex-shrink-0 transition-opacity text-white"
            [ngClass]="activeMenuItem === 'loan-applications' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0l-2.5 2.5M20 13h-3.5a1.5 1.5 0 00-1.5 1.5 1.5 1.5 0 01-1.5 1.5h-3a1.5 1.5 0 01-1.5-1.5A1.5 1.5 0 007.5 13H4m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5" />
          </svg>
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'loan-applications' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            Applications
          </span>
          @if (activeMenuItem === 'loan-applications') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>
      }

      <!-- Application Forms -->
      @if (permissionService.canAccess('applicationForms')) {
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'application-forms' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/application-forms')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <svg class="w-4 h-4 flex-shrink-0 transition-opacity text-white"
            [ngClass]="activeMenuItem === 'application-forms' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'application-forms' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            App Forms
          </span>
          @if (activeMenuItem === 'application-forms') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>
      }

    </nav>

    <!-- Settings Section -->
    @if (permissionService.canAccess('adminMgmt') || permissionService.canAccess('apiKeys') || permissionService.canAccess('webhooks')) {
    <p class="text-[9px] font-bold uppercase tracking-widest px-3 mb-2 text-white/30">Settings</p>
    <nav class="space-y-0.5">

      <!-- Admins -->
      @if (permissionService.canAccess('adminMgmt')) {
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'users' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/manage-users')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <svg class="w-4 h-4 flex-shrink-0 transition-opacity text-white"
            [ngClass]="activeMenuItem === 'users' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'users' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            Admins
          </span>
          @if (activeMenuItem === 'users') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>
      }

      <!-- API Keys -->
      @if (permissionService.canAccess('apiKeys')) {
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'api-keys' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/api-keys')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <svg class="w-4 h-4 flex-shrink-0 transition-opacity text-white"
            [ngClass]="activeMenuItem === 'api-keys' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
          </svg>
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'api-keys' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            API Keys
          </span>
          @if (activeMenuItem === 'api-keys') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>
      }

      <!-- Webhook Trigger -->
      @if (permissionService.canAccess('webhooks')) {
      <div class="group cursor-pointer rounded-lg transition-all duration-150"
        [ngClass]="activeMenuItem === 'webhook-trigger' ? 'bg-white/15 dark:bg-white/10' : 'hover:bg-white/8 dark:hover:bg-white/5'"
        (click)="navigateTo('/webhook-trigger')">
        <div class="flex items-center gap-3 px-3 py-2.5">
          <svg class="w-4 h-4 flex-shrink-0 transition-opacity text-white"
            [ngClass]="activeMenuItem === 'webhook-trigger' ? 'opacity-100' : 'opacity-40 group-hover:opacity-70'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <span class="text-xs font-semibold transition-colors"
            [ngClass]="activeMenuItem === 'webhook-trigger' ? 'text-white' : 'text-white/55 group-hover:text-white/80'">
            Webhook Trigger
          </span>
          @if (activeMenuItem === 'webhook-trigger') {
          <div class="ml-auto w-1.5 h-1.5 rounded-full bg-white/60"></div>
          }
        </div>
      </div>
      }

    </nav>
    }
  </div>

  <!-- Footer -->
  <div class="px-5 py-4 border-t border-white/10 dark:border-white/5 flex-shrink-0">
    <p class="text-[9px] font-semibold uppercase tracking-widest text-white/25">
      © {{ getCurrentYear() }} Direct S&L
    </p>
  </div>

</section>
